"use strict";

var _toConsumableArray = require("/app/front/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTxVerifier = exports.WaxJS = void 0;

var eosjs_1 = require("eosjs");

var eosjs_ecc_migration_1 = require("eosjs/dist/eosjs-ecc-migration");

var WaxSigningApi_1 = require("./WaxSigningApi");

var PROOF_WAX = 1;
var PROOF_USER = 2;

var WaxJS = /*#__PURE__*/function () {
  function WaxJS(_ref) {
    var _this = this;

    var rpcEndpoint = _ref.rpcEndpoint,
        _ref$tryAutoLogin = _ref.tryAutoLogin,
        tryAutoLogin = _ref$tryAutoLogin === void 0 ? true : _ref$tryAutoLogin,
        userAccount = _ref.userAccount,
        pubKeys = _ref.pubKeys,
        apiSigner = _ref.apiSigner,
        _ref$waxSigningURL = _ref.waxSigningURL,
        waxSigningURL = _ref$waxSigningURL === void 0 ? "https://www.mycloudwallet.com" : _ref$waxSigningURL,
        _ref$waxAutoSigningUR = _ref.waxAutoSigningURL,
        waxAutoSigningURL = _ref$waxAutoSigningUR === void 0 ? "https://idm-api.mycloudwallet.com/v1/accounts/auto-accept/" : _ref$waxAutoSigningUR,
        _ref$eosApiArgs = _ref.eosApiArgs,
        eosApiArgs = _ref$eosApiArgs === void 0 ? {} : _ref$eosApiArgs,
        _ref$freeBandwidth = _ref.freeBandwidth,
        freeBandwidth = _ref$freeBandwidth === void 0 ? true : _ref$freeBandwidth,
        _ref$feeFallback = _ref.feeFallback,
        feeFallback = _ref$feeFallback === void 0 ? true : _ref$feeFallback,
        _ref$verifyTx = _ref.verifyTx,
        verifyTx = _ref$verifyTx === void 0 ? defaultTxVerifier : _ref$verifyTx,
        _ref$metricURL = _ref.metricURL,
        metricURL = _ref$metricURL === void 0 ? "" : _ref$metricURL,
        _ref$returnTempAccoun = _ref.returnTempAccounts,
        returnTempAccounts = _ref$returnTempAccoun === void 0 ? false : _ref$returnTempAccoun;

    _classCallCheck(this, WaxJS);

    this.signingApi = new WaxSigningApi_1.WaxSigningApi(waxSigningURL, waxAutoSigningURL, metricURL, returnTempAccounts);
    this.rpc = new eosjs_1.JsonRpc(rpcEndpoint);
    this.rpcUrl = rpcEndpoint;
    this.waxSigningURL = waxSigningURL;
    this.waxAutoSigningURL = waxAutoSigningURL;
    this.apiSigner = apiSigner;
    this.eosApiArgs = eosApiArgs;
    this.freeBandwidth = freeBandwidth;
    this.feeFallback = feeFallback;
    this.metricURL = metricURL;
    this.proofWaxKey = "";
    this.verifyTx = verifyTx;
    this.returnTempAccounts = returnTempAccounts;

    if (userAccount && Array.isArray(pubKeys)) {
      // login from constructor
      this.receiveLogin({
        account: userAccount,
        keys: pubKeys
      });
    } else {
      // try to auto-login via endpoint
      if (tryAutoLogin) {
        this.signingApi.tryAutologin().then(function (response) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!response) {
                      _context.next = 6;
                      break;
                    }

                    _context.t0 = this;
                    _context.next = 4;
                    return this.signingApi.login();

                  case 4:
                    _context.t1 = _context.sent;

                    _context.t0.receiveLogin.call(_context.t0, _context.t1);

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
        });
      }
    }
  }

  _createClass(WaxJS, [{
    key: "userAccount",
    get: function get() {
      return this.user && this.user.account;
    }
  }, {
    key: "pubKeys",
    get: function get() {
      return this.user && this.user.keys;
    }
  }, {
    key: "isTemp",
    get: function get() {
      return this.user && this.user.isTemp;
    }
  }, {
    key: "createInfo",
    get: function get() {
      return this.user && this.user.createData;
    }
  }, {
    key: "login",
    value: function login() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.user) {
                  _context2.next = 6;
                  break;
                }

                _context2.t0 = this;
                _context2.next = 4;
                return this.signingApi.login();

              case 4:
                _context2.t1 = _context2.sent;

                _context2.t0.receiveLogin.call(_context2.t0, _context2.t1);

              case 6:
                return _context2.abrupt("return", this.user.account);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "isAutoLoginAvailable",
    value: function isAutoLoginAvailable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.user) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", true);

              case 4:
                _context3.next = 6;
                return this.signingApi.tryAutologin();

              case 6:
                if (!_context3.sent) {
                  _context3.next = 13;
                  break;
                }

                _context3.t0 = this;
                _context3.next = 10;
                return this.signingApi.login();

              case 10:
                _context3.t1 = _context3.sent;

                _context3.t0.receiveLogin.call(_context3.t0, _context3.t1);

                return _context3.abrupt("return", true);

              case 13:
                return _context3.abrupt("return", false);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.user = null;
                this.api = null;

                if (this.signingApi) {
                  this.signingApi.logout();
                }

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "userAccountProof",
    value: function userAccountProof(nonce, description) {
      var verify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var data, message, _iterator, _step, key;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.user) {
                  _context5.next = 2;
                  break;
                }

                throw new Error("User is not logged in");

              case 2:
                _context5.next = 4;
                return this.signingApi.proofWindow(nonce, PROOF_USER, description);

              case 4:
                data = _context5.sent;
                message = nonce;

                if (verify) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return", Object.assign(Object.assign({}, data), {
                  message: message
                }));

              case 8:
                _iterator = _createForOfIteratorHelper(this.pubKeys);
                _context5.prev = 9;

                _iterator.s();

              case 11:
                if ((_step = _iterator.n()).done) {
                  _context5.next = 19;
                  break;
                }

                key = _step.value;
                _context5.next = 15;
                return eosjs_ecc_migration_1.ecc.verify(data.signature, message, key);

              case 15:
                if (!_context5.sent) {
                  _context5.next = 17;
                  break;
                }

                return _context5.abrupt("return", true);

              case 17:
                _context5.next = 11;
                break;

              case 19:
                _context5.next = 24;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5["catch"](9);

                _iterator.e(_context5.t0);

              case 24:
                _context5.prev = 24;

                _iterator.f();

                return _context5.finish(24);

              case 27:
                return _context5.abrupt("return", false);

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[9, 21, 24, 27]]);
      }));
    }
  }, {
    key: "waxProof",
    value: function waxProof(nonce) {
      var verify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var data, message;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.user) {
                  _context6.next = 2;
                  break;
                }

                throw new Error("User is not logged in");

              case 2:
                if (!(this.proofWaxKey === "")) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 5;
                return this.getRequiredKeys();

              case 5:
                _context6.next = 7;
                return this.signingApi.proofWindow(nonce, PROOF_WAX, null);

              case 7:
                data = _context6.sent;
                message = "cloudwallet-verification-".concat(data.referer, "-").concat(nonce, "-").concat(data.accountName);

                if (verify) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", Object.assign(Object.assign({}, data), {
                  message: message
                }));

              case 11:
                _context6.next = 13;
                return eosjs_ecc_migration_1.ecc.verify(data.signature, message, this.proofWaxKey);

              case 13:
                return _context6.abrupt("return", _context6.sent);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getRequiredKeys",
    value: function getRequiredKeys() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var response, _iterator2, _step2, perm;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return fetch("".concat(this.rpcUrl, "/v1/chain/get_account"), {
                  body: JSON.stringify({
                    account_name: "proof.wax"
                  }),
                  method: "POST"
                }).then(function (e) {
                  return e.json();
                });

              case 2:
                response = _context7.sent;

                if (response.permissions) {
                  _iterator2 = _createForOfIteratorHelper(response.permissions);

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      perm = _step2.value;

                      if (perm.perm_name === "active") {
                        this.proofWaxKey = perm.required_auth.keys[0].key;
                      }
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "receiveLogin",
    value: function receiveLogin(data) {
      var _this2 = this;

      this.user = data;
      var signatureProvider = {
        getAvailableKeys: function getAvailableKeys() {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.t0 = [];
                    _context8.t1 = _toConsumableArray(this.user.keys);
                    _context8.t2 = _toConsumableArray;
                    _context8.t4 = this.apiSigner;

                    if (!_context8.t4) {
                      _context8.next = 8;
                      break;
                    }

                    _context8.next = 7;
                    return this.apiSigner.getAvailableKeys();

                  case 7:
                    _context8.t4 = _context8.sent;

                  case 8:
                    _context8.t3 = _context8.t4;

                    if (_context8.t3) {
                      _context8.next = 11;
                      break;
                    }

                    _context8.t3 = [];

                  case 11:
                    _context8.t5 = _context8.t3;
                    _context8.t6 = (0, _context8.t2)(_context8.t5);
                    return _context8.abrupt("return", _context8.t0.concat.call(_context8.t0, _context8.t1, _context8.t6));

                  case 14:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          }));
        },
        sign: function sign(sigArgs) {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
            var originalTx, _yield$this$signingAp, serializedTransaction, signatures, augmentedTx;

            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return this.api.deserializeTransactionWithActions(sigArgs.serializedTransaction);

                  case 2:
                    originalTx = _context9.sent;
                    _context9.next = 5;
                    return this.signingApi.signing(originalTx, sigArgs.serializedTransaction, !this.freeBandwidth, this.feeFallback);

                  case 5:
                    _yield$this$signingAp = _context9.sent;
                    serializedTransaction = _yield$this$signingAp.serializedTransaction;
                    signatures = _yield$this$signingAp.signatures;
                    _context9.next = 10;
                    return this.api.deserializeTransactionWithActions(serializedTransaction);

                  case 10:
                    augmentedTx = _context9.sent;
                    this.verifyTx(this.user, originalTx, augmentedTx);
                    sigArgs.serializedTransaction = serializedTransaction;
                    _context9.t0 = serializedTransaction;
                    _context9.t1 = [];
                    _context9.t2 = _toConsumableArray(signatures);
                    _context9.t3 = _toConsumableArray;
                    _context9.t5 = this.apiSigner;

                    if (!_context9.t5) {
                      _context9.next = 22;
                      break;
                    }

                    _context9.next = 21;
                    return this.apiSigner.sign(sigArgs);

                  case 21:
                    _context9.t5 = _context9.sent.signatures;

                  case 22:
                    _context9.t4 = _context9.t5;

                    if (_context9.t4) {
                      _context9.next = 25;
                      break;
                    }

                    _context9.t4 = [];

                  case 25:
                    _context9.t6 = _context9.t4;
                    _context9.t7 = (0, _context9.t3)(_context9.t6);
                    _context9.t8 = _context9.t1.concat.call(_context9.t1, _context9.t2, _context9.t7);
                    return _context9.abrupt("return", {
                      serializedTransaction: _context9.t0,
                      signatures: _context9.t8
                    });

                  case 29:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9, this);
          }));
        }
      };
      this.api = new eosjs_1.Api(Object.assign(Object.assign({}, this.eosApiArgs), {
        rpc: this.rpc,
        signatureProvider: signatureProvider
      }));
      var transact = this.api.transact.bind(this.api); // We monkeypatch the transact method to overcome timeouts
      // firing the pop-up which some browsers enforce, such as Safari.
      // By pre-creating the pop-up window we will interact with,
      // we ensure that it is not going to be rejected due to a delayed
      // pop up that would otherwise occur post transaction creation

      this.api.transact = function (transaction, namedParams) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return this.signingApi.prepareTransaction(transaction);

                case 2:
                  _context10.next = 4;
                  return transact(transaction, namedParams);

                case 4:
                  return _context10.abrupt("return", _context10.sent);

                case 5:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
      };
    }
  }]);

  return WaxJS;
}();

exports.WaxJS = WaxJS;

function defaultTxVerifier(user, originalTx, augmentedTx) {
  var originalActions = originalTx.actions;
  var augmentedActions = augmentedTx.actions;

  if (JSON.stringify(originalActions) !== JSON.stringify(augmentedActions.slice(augmentedActions.length - originalActions.length))) {
    throw new Error("Augmented transaction actions has modified actions from the original.\nOriginal: ".concat(JSON.stringify(originalActions, undefined, 2), "\nAugmented: ").concat(JSON.stringify(augmentedActions, undefined, 2)));
  }

  var _iterator3 = _createForOfIteratorHelper(augmentedActions.slice(0, augmentedActions.length - originalActions.length)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var extraAction = _step3.value;
      var userAuthedAction = extraAction.authorization.find(function (auth) {
        return auth.actor === user.account;
      });

      if (userAuthedAction) {
        if (extraAction.account === "eosio.token" && extraAction.name === "transfer") {
          var noopAction = augmentedActions[0];

          if (extraAction.data.to === "txfee.wax" && extraAction.data.memo.startsWith("WAX fee for ") && JSON.stringify(noopAction) === JSON.stringify({
            account: "boost.wax",
            name: "noop",
            authorization: [{
              actor: "boost.wax",
              permission: "paybw"
            }],
            data: {}
          })) {
            continue;
          }
        }

        if (extraAction.account === "eosio" && extraAction.name === "buyrambytes") {
          if (extraAction.data.receiver === user.account) {
            continue;
          }
        }

        throw new Error("Augmented transaction actions has an extra action from the original authorizing the user.\nOriginal: ".concat(JSON.stringify(originalActions, undefined, 2), "\nAugmented: ").concat(JSON.stringify(augmentedActions, undefined, 2)));
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}

exports.defaultTxVerifier = defaultTxVerifier;